<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-shopping</v-icon>Adicionar
          produto
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="productName"
              :rules="nameRules"
              label="Nome do produto"
              required
              filled
            ></v-text-field>

            <v-text-field
              v-model="productPrice"
              :rules="priceRules"
              label="Preço do produto"
              required
              filled
            ></v-text-field>

            <v-text-field
              v-model="productCode"
              :rules="priceRules"
              label="Código do produto (Opcional)"
              required
              filled
            ></v-text-field>
            <v-card-actions>
              <v-btn
                color="deep-purple lighten-2"
                text
                block
                @click="addProductToCategory"
                :disabled="!valid"
                :loading="loading"
              >
                Adicionar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";
export default {
  name: "OpenAppendProductToCategory",
  data: () => ({
    newPassword: "",
    productName: "",
    productPrice: "",
    productCode: "",
    dialog: false,
    index: Number,
    valid: true,
    value: true,
    loading: false,
    nameRules: [
      v => !!v || "Nome é requerido",
      v => (v && v.length >= 3) || "Deve ter no mínimo 3 caracter"
    ],
    priceRules: [
      v => !!v || "Preço é requerido",
      v => (v && v.length >= 3) || "Deve ter no mínimo 3 caracter"
    ]
  }),
  methods: {
    addProductToCategory() {
      if (this.$refs.form.validate() && this.index != null) {
        // alert(this.index);
        const payload = {
          productName: this.productName,
          ProductCodeExternal: this.productCode,
          productPrice: parseFloat(this.productPrice),
          productCategoryId: this.index
        };
        this.$store.dispatch("createProduct", payload);
      }
    }
  },
  created() {
    const self = this;
    eventBus.$on("OpenAppendProductToCategory", function(value) {
      self.dialog = value.dialog;
      self.index = value.index;
    });
  }
};
</script>

<style scoped>
.m-center {
  text-align: center;
}
</style>
